export default "__VITE_ASSET__Bm06wiRc__"